import { render } from "./editModal.vue?vue&type=template&id=5845af4a&scoped=true"
import script from "./editModal.vue?vue&type=script&lang=js"
export * from "./editModal.vue?vue&type=script&lang=js"

import "./editModal.vue?vue&type=style&index=0&id=5845af4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845af4a"]])

export default __exports__